import './styles/globals.css'
import '@repo/ui/fonts'

import { scrubPii } from '@repo/pii-scrubber'
import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { Toaster } from '@/components/ui/sonner'

import { queryClient } from './lib/query-client'
import { router } from './router'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.PROD && Boolean(import.meta.env.VITE_SENTRY_DSN),
  environment: 'production',
  sendDefaultPii: false,
  beforeSend(event) {
    return scrubPii(event)
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={<p>Algo deu errado. Recarregue a página.</p>}
    >
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster position="top-center" />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
